import { Inject, inject, InjectionToken } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { Bookmark, BookmarkBody, PostBookmark } from '../models/bookmark';
import {
  SOFTLINE_API_BOOKMARK,
  SOFTLINE_API_BOOKMARK_DELETE,
} from '../softapps-core.api';

export interface BookmarkRepositoryParams {
  category: string;
  subCategory: string;
}

export const BOOKMARK_REPOSITORY_PARAMS = new InjectionToken<BookmarkRepositoryParams>(
  'BookmarkRepositoryParams'
);

// http://devsrv01:81/api/portal-service/swagger-ui/index.html#/

export class BookmarkRepository<T extends Bookmark<B>, B extends BookmarkBody> {
  readonly #dataAccess = inject(ApiDataAccess);
  readonly apiPath = SOFTLINE_API_BOOKMARK;

  constructor(
    @Inject(BOOKMARK_REPOSITORY_PARAMS) private params: BookmarkRepositoryParams
  ) {
    //
  }

  load(): Promise<T[]> {
    return this.#dataAccess.get({
      path: this.apiPath,
      pathParams: {
        category: this.params.category,
        subCategory: this.params.subCategory,
      },
    });
  }

  create(bookmark: PostBookmark<B>): Promise<T> {
    return this.#dataAccess.create(
      {
        path: this.apiPath,
        pathParams: {
          category: this.params.category,
          subCategory: this.params.subCategory,
        },
      },
      bookmark
    );
  }

  delete(key: string): Promise<void> {
    return this.#dataAccess.delete({
      path: SOFTLINE_API_BOOKMARK_DELETE,
      pathParams: { key },
    });
  }
}
